import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center justify-center px-4 py-24 text-center md:py-32">
      <div className="relative">
        <span className="font-heading text-[110px] font-black leading-none text-primary-100 md:text-[180px]">
          404
        </span>
        <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-accent-500 text-primary-950 md:h-20 md:w-20">
          <i className="ri-ghost-line text-3xl md:text-4xl" />
        </span>
      </div>
      <h1 className="mt-6 font-heading text-2xl font-black text-foreground-950 md:text-3xl">页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
        抱歉，你访问的页面不存在或已被移除。不妨回到首页，继续探索 97影院的最新影视资源。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-base" />
          返回首页
        </Link>
        <Link
          to="/category"
          className="whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
        >
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}